import r from '~/utils/render-utils';

const PageSerbuSeruWinnerList = () => import(/* webpackChunkName: 'serbuseru' */ '~/pages/SerbuSeru/winners');

const serbuseru = [
  { path: '/serbu-seru/:product_id/pemenang', component: r(PageSerbuSeruWinnerList), name: 'serbuseru_winners' },
];

export default serbuseru;
